import React from 'react';
import { Zuweisung } from '../../types';
import { formatDate } from '../../utils/dateUtils';

interface DeleteZuweisungDialogProps {
  zuweisung: Zuweisung;
  onConfirm: () => void;
  onCancel: () => void;
}

const DeleteZuweisungDialog: React.FC<DeleteZuweisungDialogProps> = ({
  zuweisung,
  onConfirm,
  onCancel,
}) => {
  const getZeitslotLabel = (zeitslot: string): string => {
    return zeitslot === 'VORMITTAG' ? 'Vormittag' : 'Nachmittag';
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">
          Zuweisung löschen
        </h3>
        <p className="text-gray-600 mb-4">
          Möchten Sie diese Zuweisung wirklich löschen?
        </p>
        <div className="bg-gray-50 p-4 rounded mb-6">
          <p className="text-sm text-gray-700">
            <span className="font-medium">Arzt:</span>{' '}
            {zuweisung.arzt 
              ? `${zuweisung.arzt.vorname} ${zuweisung.arzt.nachname}`
              : '-'}
          </p>
          <p className="text-sm text-gray-700">
            <span className="font-medium">Praxis:</span>{' '}
            {zuweisung.praxis?.name || '-'}
          </p>
          <p className="text-sm text-gray-700">
            <span className="font-medium">Datum:</span>{' '}
            {formatDate(zuweisung.datum)}
          </p>
          <p className="text-sm text-gray-700">
            <span className="font-medium">Zeitslot:</span>{' '}
            {getZeitslotLabel(zuweisung.zeitslot)}
          </p>
        </div>
        <div className="flex justify-end space-x-3">
          <button
            onClick={onCancel}
            className="px-4 py-2 text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200"
          >
            Abbrechen
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 text-white bg-red-600 rounded-md hover:bg-red-700"
          >
            Löschen
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteZuweisungDialog;
